<template>
  <div class="mdc-layout-grid__inner">
    <div class="mdc-layout-grid__cell
                mdc-layout-grid__cell--span-4">
    </div>
    <div class="mdc-layout-grid__cell
                mdc-layout-grid__cell--span-4">
      <div class="mdc-card">
        <section class="mdc-card__media" id="portrait">
          <span class="mdc-toolbar__icon circular--portrait">
            <img src="../assets/Profile_pic_square_mid.png">
          </span>
        </section>
        <section class="mdc-card__primary">
          <h1 class="mdc-card__title mdc-card__title--large">Ajay Addepalle</h1>
        </section>
        <section class="mdc-card__supporting-text">
          <h2 class="mdc-card__subtitle">Software Engineer</h2>
        </section>
        <section class="mdc-card__actions">
          <a href="mailto:ajay.addepalle@gmail.com"
             class="mdc-button mdc-button__icon mdc-button--accent"
             title="Email me @ ajay.addepalle@gmail.com">
            <i class="material-icons" style="vertical-align: middle">email</i> Email
          </a>
          <a href="https://github.com/ajay-addepalle"
             class="mdc-button mdc-button__icon mdc-button--accent"
             title="See my open source project work @ https://github.com/aakoss">
            <i class="material-icons" style="vertical-align: middle">code</i> Github
          </a>
        </section>
      </div>

      <div class="mdc-layout-grid__cell
                  mdc-layout-grid__cell--span-4">
      </div>
    </div>
  </div>
</template>

<script>
  export default {}
</script>

<style lang="scss">
  @import '~@material/card/mdc-card';
  @import '~@material/button/mdc-button';

  .circular--portrait {

  }

  .circular--portrait img {
    border-radius: 50%;
    width: 120px;

  }
</style>



// WEBPACK FOOTER //
// Contact.vue?85d25cac